export default __webpack_public_path__ + "8da91d8a3214d6e8e45c30b070af175f.png";